export default __webpack_public_path__ + "static/media/admin-yard-update.425e131f.png";